<template>
  <div id="busmaster">
    <div class="container" style="margin-top: 10px">
      <div class="admin-wrap">
        <div class="row mb-5">
          <div class="col-lg-7">
            <h3 class="text-left">
              {{ $route.name }}
              <el-select v-model="ddlBusType" @change="getBusList()" placeholder="Select Type">
                <el-option v-for="item in busTypeList" :key="item" :label="item" :value="item"> </el-option>
              </el-select>
            </h3>
          </div>
          <div class="col-lg-5">
            <div class="searchingArea attendance-search">
              <!--<button v-on:click="createNewBus()"-->
              <!--class="btn btn-primary waves-effect waves-light m-r-10 btnFamilyIDSearch">New Bus-->
              <!--</button>-->

              <el-button type="primary" round class="float-right large-btn classManage-filter" v-on:click="createNewBus()">
                <i class="material-icons"> directions_bus </i> New Bus
              </el-button>
            </div>
          </div>
        </div>
        <!--<div class="row header mb-5">-->
        <!--<label>Select Type</label>-->
        <!--<el-select v-model="ddlBusType" @change="getBusList()">-->
        <!--<el-option v-for="item in busTypeList" :key="item" :label="item" :value="item">-->
        <!--</el-option>-->
        <!--</el-select>-->
        <!--</div>-->
        <div class="row header mb-5" v-if="intBusList.length < 1">
          <div class="empty-list_image">
            <img src="../assets/attendance.jpg" />
          </div>
        </div>
      </div>
      <div class="row" style="margin-top: 20px" v-if="intBusList.length > 0">
        <div class="busMaster-wrap col-lg-12">
          <div class="busMaster-item mb-4" v-for="(busListInfo, index) in intBusList">
            <div class="busMaster-heading row">
              <div class="busMaster-item_title col-lg-10 col-8">
                <i class="material-icons"> directions_bus </i>
                <span>Bus No: {{ busListInfo.BusNo }}</span>
              </div>
              <div class="busMaster-item_close col-lg-2 col-4">
                <el-button icon="el-icon-plus" circle @click="assignStudentToBus(busListInfo.BusID)"></el-button>
                <el-button icon="el-icon-date" circle @click="scheduleBusNo(busListInfo)"></el-button>
                <el-button icon="el-icon-close" circle @click="showConfirmModal(busListInfo.BusID, busListInfo.BusNo)"></el-button>
              </div>
            </div>
            <div @click="busListClick(busListInfo.BusID, busListInfo.BusNo)" class="busListCLick" style="cursor: pointer">
              <i class="material-icons"> assignment </i>
              View Assigned Students
            </div>
            <div v-show="currentBusID === busListInfo.BusID">
              <div class="" v-if="intAssignedStudentsList && intAssignedStudentsList.length < 1">
                <el-alert title="No Record..." type="info" :closable="false"> </el-alert>
              </div>
              <div v-if="intAssignedStudentsList && intAssignedStudentsList.length > 0" class="datatable_group">
                <div>
                  <el-button type="primary" class="float-right large-btn classManage-filter" style="margin-bottom: 10px" v-on:click="download()">
                    Download
                  </el-button>
                </div>
                <div>
                  <data-tables :data="intAssignedStudentsList" :action-col="AssignedStudentsListActionCol">
                    <el-table-column
                      v-for="assignedStudentsListInfo in assignedStudentsListInt"
                      :prop="assignedStudentsListInfo.prop"
                      :label="assignedStudentsListInfo.label"
                      :key="assignedStudentsListInfo.prop"
                      sortable="custom"
                    >
                    </el-table-column>
                  </data-tables>
                </div>
              </div>
            </div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
    <b-modal size="lg" title="New Bus" ok-only ok-variant="secondary" hide-footer ref="newBusModal">
      <div class="row ml-2 mr-2">
        <div class="row col-lg-12">
          <div class="col-lg-6">
            <label>Type</label>
            <el-select v-model="ddlNewBusType" class="ddlNewBusType">
              <el-option v-for="item in busTypeList" :key="item" :label="item" :value="item"> </el-option>
            </el-select>
          </div>
          <div class="col-lg-6">
            <label>Bus No</label>
            <input type="text" class="form-control" v-model="inputNewBusNo" />
          </div>
        </div>

        <div class="col-lg-12">
          <button v-on:click="saveNewBus()" class="btn btn-primary waves-effect waves-light m-r-10 btnFamilyIDSearch">Save</button>
        </div>
      </div>
    </b-modal>
    <b-modal size="lg" title="Assigned Students" ok-only ok-variant="secondary" hide-footer ref="assignedStudentsModal">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div v-if="intAssignedStudentsList.length > 0" class="datatable_group">
          <data-tables :data="intAssignedStudentsList" :action-col="AssignedStudentsListActionCol">
            <el-table-column
              v-for="assignedStudentsListInfo in assignedStudentsListInt"
              :prop="assignedStudentsListInfo.prop"
              :label="assignedStudentsListInfo.label"
              :key="assignedStudentsListInfo.prop"
              sortable="custom"
            >
            </el-table-column>
          </data-tables>
        </div>
      </div>
    </b-modal>
    <b-modal size="lg" title="Assign Students" ok-only ok-variant="secondary" hide-footer ref="assignStudentsModal">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div v-if="intAssignStudentsList.length > 0" class="datatable_group">
          <el-row style="margin-bottom: 10px">
            <el-input v-model="assignStudentsListSearchFilter">
              <template slot="prepend">Search by First Name</template>
            </el-input>
          </el-row>
          <el-table
            :data="
              intAssignStudentsList
                .filter(data => !assignStudentsListSearchFilter || data.Full_Name.toLowerCase().includes(assignStudentsListSearchFilter.toLowerCase()))
                .slice((assignStudentsListCurrentPage - 1) * assignStudentsListPageSize, assignStudentsListCurrentPage * assignStudentsListPageSize)
            "
            @selection-change="changeSelection"
            :row-key="getRowKey"
            ref="articleTable"
          >
            <el-table-column type="selection" width="55" :reserve-selection="true"> </el-table-column>
            <el-table-column
              v-for="assignStudentsListInfo in assignStudentsList"
              :prop="assignStudentsListInfo.prop"
              :label="assignStudentsListInfo.label"
              :key="assignStudentsListInfo.prop"
              sortable
            >
            </el-table-column>
          </el-table>
          <el-pagination
            @current-change="assignStudentsListChangePage"
            @size-change="assignStudentsListChangePageSize"
            :page-sizes="[20, 40, 60, 80]"
            :page-size="assignStudentsListPageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="assignStudentsListTotal"
          >
          </el-pagination>
        </div>
      </div>
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <button v-on:click="assignToBus()" class="btn btn-primary waves-effect waves-light m-r-10">Assign</button>
      </div>
    </b-modal>
    <b-modal id="scheduleBusModal" size="lg" title="Schedule Bus No Assignment" ok-only ok-variant="secondary" hide-footer ref="scheduleBusShowModal">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <label>Schedule Date for ( {{ currentBusNoName }} )</label>
          <div class="date">
            <el-date-picker
              v-model="inputScheduleBusDate"
              format="dd/MM/yyyy"
              @input="getScheduleAssignStudents()"
              value-format="dd/MM/yyyy"
              type="date"
              placeholder="Pick a date"
              :picker-options="inputScheduleBusDateDatePickerOptions"
            >
            </el-date-picker>
          </div>
          <div class="empty-list_image" v-if="intUnAssignedScheduleBusNoStudentsList.length < 1">
            <strong>No Data Found...</strong>
            <img src="../assets/notfound.png" />
          </div>
          <div v-if="intUnAssignedScheduleBusNoStudentsList.length > 0" class="datatable_group">
            <hr class="custom-hr" />
            <div class="col-lg-12">
              <el-row style="margin-bottom: 10px" class="classManage-ActionBar">
                <el-col :span="24">
                  <el-input v-model="unAssignedScheduleBusNoStudentsListFilters[0].value">
                    <template slot="prepend">Search First Name</template>
                  </el-input>
                </el-col>
              </el-row>
              <data-tables
                :data="intUnAssignedScheduleBusNoStudentsList"
                :filters="unAssignedScheduleBusNoStudentsListFilters"
                @selection-change="changeSelection"
              >
                <el-table-column type="selection" width="55" :reserve-selection="true"> </el-table-column>
                <el-table-column
                  v-for="unAssignedScheduleBusNoStudentsListInfo in unAssignedScheduleBusNoStudentsList"
                  :prop="unAssignedScheduleBusNoStudentsListInfo.prop"
                  :label="unAssignedScheduleBusNoStudentsListInfo.label"
                  :key="unAssignedScheduleBusNoStudentsListInfo.prop"
                  sortable="custom"
                >
                </el-table-column>
              </data-tables>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <hr class="custom-hr" />
              <div>
                <div class="col-lg-12">
                  <button v-on:click="saveScheduleAssignStudents()" class="btn btn-primary waves-effect waves-light m-r-10 btnFamilyIDSearch float-right">
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal id="deleteBusModal" size="lg" title="Delete Bus" ok-only ok-variant="secondary" hide-footer ref="deleteBusShowModal">
      <div class="col-lg-12">
        <h1>Are you sure to delete Bus No: {{ selectedBusNo }} ?</h1>
      </div>
      <hr class="custom-hr" />
      <div class="col-lg-12">
        <button v-on:click="updateBus(selectedBusID)" class="btn btn-primary waves-effect waves-light m-r-10 btnFamilyIDSearch">Confirm Delete</button>
      </div>
    </b-modal>
  </div>
</template>
<script>
import DataSource from '../data/datasource'
import XLSX from 'xlsx'

export default {
  name: 'BusMaster',
  async created() {},
  data() {
    return {
      inputNewBusNo: '',
      currentBusNo: '',
      currentBusType: '',
      assignStudentsListSearchFilter: '',
      multipleSelection: [],

      ddlBusType: '',
      busTypeList: ['IN', 'OUT'],
      currentBusID: '',
      deleteFromBus: false,
      ddlNewBusType: '',
      currentBusNoName: '',

      inputScheduleBusDate: '',
      inputScheduleBusDateDatePickerOptions: {
        disabledDate(time) {
          return time <= new Date()
        },
      },

      intBusList: [],
      busList: [
        {
          prop: 'BusNo',
          label: 'Bus No',
        },
      ],
      busListActionCol: {
        label: 'Delete',
        props: {
          align: 'center',
        },
        buttons: [
          {
            props: {
              type: 'primary',
              icon: 'el-icon-edit',
            },
            handler: row => {
              this.updateBus(row.BusID)
            },
            label: 'Delete',
          },
        ],
      },

      intAssignedStudentsList: [],
      assignedStudentsListInt: [
        {
          prop: 'Index_No',
          label: 'Student ID',
        },
        {
          prop: 'Full_Name',
          label: 'First Name',
        },
        {
          prop: 'Middle_name',
          label: 'Middle Name',
        },
        {
          prop: 'Last_name',
          label: 'Last Name',
        },
      ],
      AssignedStudentsListActionCol: {
        label: 'Delete',
        props: {
          align: 'center',
        },
        buttons: [
          {
            props: {
              type: 'primary',
              icon: 'el-icon-edit',
            },
            handler: row => {
              this.deleteFromBusNo(row.Student_ID)
            },
            label: 'Delete',
          },
        ],
      },

      intAssignStudentsList: [],
      assignStudentsListPageSize: 20,
      assignStudentsListTotal: 0,
      assignStudentsListCurrentPage: 1,
      assignStudentsList: [
        {
          prop: 'Index_No',
          label: 'Student ID',
        },
        {
          prop: 'Full_Name',
          label: 'First Name',
        },
        {
          prop: 'Middle_name',
          label: 'Middle Name',
        },
        {
          prop: 'Last_name',
          label: 'Last Name',
        },
        {
          prop: 'busInOut',
          label: 'Bus No',
        },
        {
          prop: 'schoolName',
          label: 'School',
        },
      ],

      intUnAssignedScheduleBusNoStudentsList: [],
      unAssignedScheduleBusNoStudentsList: [
        {
          prop: 'Index_No',
          label: 'Student ID',
        },
        {
          prop: 'Full_Name',
          label: 'First Name',
        },
        {
          prop: 'Middle_name',
          label: 'Middle Name',
        },
        {
          prop: 'Last_name',
          label: 'Last Name',
        },
      ],
      unAssignedScheduleBusNoStudentsListFilters: [
        {
          prop: ['Full_Name'],
          value: '',
        },
      ],

      selectedBusNo: '',
      selectedBusID: '',

      exportBusNoName: '',
    }
  },
  methods: {
    async getBusList() {
      this.$vs.loading()
      try {
        this.intBusList = []

        const response = await DataSource.shared.getBusMasterList(this.ddlBusType)
        if (response) {
          if (response.code === '2') {
            this.$notify({
              title: 'No Record',
              message: 'No Bus Created...',
            })
          } else if (response.code === '99') {
            console.log('getBusMasterList Error')
          } else if (response.code === '88') {
            window.location.replace('/')
          } else {
            this.intBusList = response.Table
          }
        }
      } catch (e) {
        this.results = e
      }
      this.$vs.loading.close()
    },
    async getActiveStudentListBySchoolIDOfBusNo(busID, type) {
      this.$vs.loading()
      try {
        if (type === 'IN') {
          this.intAssignedStudentsList = []
        } else {
          this.intAssignStudentsList = []
        }

        const response = await DataSource.shared.getActiveStudentListBySchoolIDOfBusNo(busID, type)

        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            this.$notify.error({
              title: 'Error',
              message: 'Get Student List By Bus No Error!',
            })
          } else if (response.code === '2') {
            if (type === 'IN') {
              this.intAssignedStudentsList = []
            } else {
              this.intAssignStudentsList = []
            }
          } else {
            if (type === 'IN') {
              this.intAssignedStudentsList = response.Table

              if (this.deleteFromBus === true) {
                this.deleteFromBus = false
              }
            } else {
              // let resultTable = response.Table;
              // this.intAssignStudentsList = [];
              // this.intAssignStudentsList = resultTable.filter(d => {
              //     return d.Bus_No !== this.currentBusNo;
              // });
              //
              // this.assignStudentsListTotal = this.intAssignStudentsList.length;
              // this.assignStudentsListCurrentPage = 1;
              // this.assignStudentsListPageSize = 20;
              // if (this.deleteFromBus === false){
              //     this.$refs.assignStudentsModal.show();
              // }else{
              //     this.deleteFromBus = false;
              // }

              this.intAssignStudentsList = response.Table

              this.assignStudentsListTotal = this.intAssignStudentsList.length
              this.assignStudentsListCurrentPage = 1
              this.assignStudentsListPageSize = 20

              if (this.deleteFromBus === false) {
                this.$refs.assignStudentsModal.show()
              } else {
                this.deleteFromBus = false
              }

              this.getActiveStudentListBySchoolIDOfBusNo(busID, 'IN')
            }
          }
        }
      } catch (e) {
        this.results = e
      }
      this.$vs.loading.close()
    },
    async saveNewBus() {
      try {
        if (this.inputNewBusNo === '' || this.ddlNewBusType === '') {
          this.$notify({
            title: 'Require',
            message: 'Require all fields...',
          })
        } else {
          this.$vs.loading()

          const response = await DataSource.shared.saveBusMasterList(this.inputNewBusNo, this.ddlNewBusType)
          if (response) {
            if (response.code === '88') {
              window.location.replace('/')
            } else if (response.code === '99') {
              this.$notify.error({
                title: 'Error',
                message: 'Save New Bus Error!',
              })
            } else if (response.code === '2') {
              this.$notify.error({
                title: 'Duplicated',
                message: 'Bus No Existing',
              })
            } else {
              this.$notify({
                title: 'Success',
                message: 'Successfully Saved!',
                type: 'success',
              })
              this.getBusList()
              this.$refs.newBusModal.hide()
            }
          }
        }
      } catch (e) {
        this.results = e
      }
      this.$vs.loading.close()
    },
    async updateBus(busID) {
      this.$refs.deleteBusShowModal.hide()
      this.$vs.loading()
      try {
        const response = await DataSource.shared.updateBusMasterList(busID, 'VOID')
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            this.$notify.error({
              title: 'Error',
              message: 'Save New Bus Error!',
            })
          } else {
            this.$notify({
              title: 'Success',
              message: 'Successfully Update!',
              type: 'success',
            })
            this.getBusList()
          }
        }
      } catch (e) {
        this.results = e
      }
      this.$vs.loading.close()
    },
    async assignToBus() {
      try {
        let studentsList = []

        this.multipleSelection.forEach((m, index) => {
          let studentsListTemp = {
            busID: this.currentBusID,
            studentID: m.Student_ID,
          }

          studentsList.push(studentsListTemp)
        })

        const response = await DataSource.shared.updateStudentBusNo(JSON.stringify(studentsList), 'UPDATE')
        if (response) {
          if (response.code === '1') {
            this.$notify({
              title: 'Success',
              message: 'Successfully saved',
              type: 'success',
            })

            this.currentBusID = ''
            this.$refs.assignStudentsModal.hide()
          } else if (response.code === '88') {
            window.location.replace('/')
          } else {
            this.$notify.error({
              title: 'Error',
              message: 'Assigned Student to Bus No Error!',
            })
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async deleteFromBusNo(studentID) {
      try {
        this.deleteFromBus = true

        let studentsList = []
        let studentsListTemp = {
          studentID: studentID,
          busID: this.currentBusID,
        }
        studentsList.push(studentsListTemp)

        const response = await DataSource.shared.updateStudentBusNo(JSON.stringify(studentsList), 'DELETE')
        if (response) {
          if (response.code === '1') {
            this.$notify({
              title: 'Success',
              message: 'Successfully saved',
              type: 'success',
            })

            this.getActiveStudentListBySchoolIDOfBusNo(this.currentBusID, 'IN')
          } else if (response.code === '88') {
            window.location.replace('/')
          } else {
            this.$notify.error({
              title: 'Error',
              message: 'Remove Student from Bus No Error!',
            })
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    async getScheduleAssignStudents() {
      try {
        this.intUnAssignedScheduleBusNoStudentsList = []
        this.multipleSelection = []

        this.$vs.loading()

        const response = await DataSource.shared.getUnAssignStudentListFromBusScheduleByBusIDEffectiveDate(this.currentBusType, this.inputScheduleBusDate)
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            console.log('getUnAssignStudentListFromBusScheduleByBusIDEffectiveDate error!')
          } else if (response.code === '2') {
            this.intUnAssignedScheduleBusNoStudentsList = []
          } else {
            this.intUnAssignedScheduleBusNoStudentsList = response.Table
          }

          this.$vs.loading.close()
        }

        this.$vs.loading.close()
      } catch (e) {
        this.results = e
      }
    },
    async saveScheduleAssignStudents() {
      try {
        if (this.inputScheduleBusDate === '') {
          this.$notify({
            title: 'Required',
            message: 'Please select effective date...',
          })
        } else if (this.multipleSelection.length < 1) {
          this.$notify({
            title: 'Required',
            message: 'Please select student list',
          })
        } else {
          let scheduleBusAssignList = []

          this.multipleSelection.forEach(item => {
            let scheduleBusAssignListDetails = {
              StudentID: item.Student_ID,
              BusID: this.currentBusID,
              EffectiveDate: this.inputScheduleBusDate,
              BusType: this.currentBusType,
            }

            scheduleBusAssignList.push(scheduleBusAssignListDetails)
          })

          const response = await DataSource.shared.saveScheduleBusNo(JSON.stringify(scheduleBusAssignList))
          if (response) {
            this.$vs.loading.close()
            if (response.code === '88') {
              window.location.replace('/')
            } else if (response.code === '99') {
              console.log('saveScheduleStudentClass error!')
            } else {
              this.$notify({
                title: 'Successfully',
                message: 'Successfully Saved!',
              })

              this.$refs.scheduleBusShowModal.hide()
            }
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    busListClick(BusID, BusNo) {
      this.currentBusID = BusID
      this.exportBusNoName = BusNo
      this.getActiveStudentListBySchoolIDOfBusNo(BusID, 'IN')
    },
    createNewBus() {
      this.inputNewBusNo = ''
      this.ddlNewBusType = ''
      this.$refs.newBusModal.show()
    },
    assignStudentToBus(BusID) {
      this.currentBusID = BusID
      this.getActiveStudentListBySchoolIDOfBusNo(BusID, 'NOT IN')
    },
    changeSelection(val) {
      this.multipleSelection = val
    },
    assignStudentsListChangePage(currentPage) {
      this.assignStudentsListCurrentPage = currentPage
    },
    assignStudentsListChangePageSize(currentPageSize) {
      this.assignStudentsListPageSize = currentPageSize
    },
    scheduleBusNo(busInfo) {
      this.inputScheduleBusDate = ''
      this.currentBusID = busInfo.BusID
      this.currentBusType = busInfo.BusType
      this.currentBusNoName = busInfo.BusNo

      this.intUnAssignedScheduleBusNoStudentsList = []
      this.inputScheduleBusDate = ''

      this.$refs.scheduleBusShowModal.show()
    },
    showConfirmModal(BusID, BusNo) {
      this.selectedBusID = BusID
      this.selectedBusNo = BusNo
      this.$refs.deleteBusShowModal.show()
    },
    download() {
      let exportFinal = []

      this.intAssignedStudentsList.forEach(m => {
        let tempList = {
          'Student No': m.Index_No,
          'First Name': m.Full_Name,
          'Middle Name': m.Middle_name,
          'Last Name': m.Last_name,
          'Active Class': m.activeClass,
          'Active Level': m.activeLevel,
          'Pending Class': m.pendingClass,
          'Pending Level': m.pendingLevel,
        }

        exportFinal.push(tempList)
      })

      var wb2 = XLSX.utils.book_new() // make Workbook of Excel

      var sheet = XLSX.utils.json_to_sheet(exportFinal)

      XLSX.utils.book_append_sheet(wb2, sheet, 'sheet') // sheetAName is name of Worksheet

      XLSX.writeFile(wb2, this.exportBusNoName + ' Assigned List.xlsx') // name of the file is 'book.xlsx'
    },
  },
}
</script>

<style scoped>
.ddlNewBusType {
  width: 100%;
}
</style>
